module.exports = {
	"jeu": {
		"produits": {
			"produit": [
				{
					"groupe": "a",
					"categorie": "1",
					"nom": "gel_antiseptique",
					"bulle": "Solution antiseptique",
					"explication": "La solution antiseptique peut être utilisée pour nettoyer une plaie simple. Attention, il est recommandé de nettoyer soigneusement la plaie avant l’application de la solution. Préférez les antiseptiques en petit conditionnement, car vous ne les utiliserez pas souvent."
				},
				{
					"groupe": "a",
					"categorie": "1",
					"nom": "serum_phy",
					"bulle": "Sérum physiologique",
					"explication": "Le sérum physiologique est utilisé pour nettoyer le nez ou les yeux des enfants et nettoyer les yeux en cas d’infection mineure ou de corps étranger (poussière, grain de sable…). Le sérum est en général vendu en unidose pour éviter une contamination."
				},
				{
					"groupe": "a",
					"categorie": "1",
					"nom": "antalgiques",
					"bulle": "Antalgiques",
					"explication": "Les antalgiques sont des médicaments qui soulagent la douleur. Certains sont disponibles en automédication. Si vous utilisez des antalgiques, n’oubliez pas de respecter la notice, notamment sur le dosage. Regardez bien la Dénomination Commune Internationale de vos médicaments. Il s’agit du ou des principes actifs qui le composent. En effet, un même principe actif peut être vendu sous plusieurs noms de marque. Il faut y prendre garde pour éviter de prendre plusieurs fois le même médicament sans le savoir et éviter ainsi un surdosage."
				},
				{
					"groupe": "a",
					"categorie": "1",
					"nom": "pommade_calmante",
					"bulle": "Pommade calmante",
					"explication": "Elle a un effet en cas de piqûre d’insectes ou d’irritation cutanée. Attention, les crèmes et pommades doivent être conservées au plus entre 6 mois et un an après leur première utilisation."
				},
				{
					"groupe": "a",
					"categorie": "1",
					"nom": "pansements",
					"bulle": "Pansements",
					"explication": "Avant l’application d’un pansement sur une plaie, veillez à bien nettoyer la plaie avec du savon et de l’eau claire, puis à la sécher délicatement. Pensez à changer le pansement régulièrement jusqu’à cicatrisation."
				},
				{
					"groupe": "a",
					"categorie": "1",
					"nom": "creme_solaire",
					"bulle": "Crème solaire",
					"explication": "Attention, la crème solaire ne filtre pas la totalité des UV. Lorsqu'on achète une crème solaire, il est recommandé de veiller à :<br>- choisir un produit actif à la fois vis-à-vis des UVB et des UVA ;<br>- privilégier les indices de haute protection ;<br>- appliquer une couche suffisante sur toutes les parties du corps non couvertes par les vêtements (sans oublier les oreilles, la nuque, les mains et les pieds) ;<br>- renouveler souvent l'application (au moins toutes les deux heures) et après chaque baignade."
				},
				{
					"groupe": "a",
					"categorie": "1",
					"nom": "creme_apres_soleil",
					"bulle": "Crème après soleil",
					"explication": "Attention, les crèmes et pommades doivent être conservées au plus entre 6 mois et un an après leur première utilisation."
				},
				{
					"groupe": "a",
					"categorie": "2",
					"nom": "antidiarrheique",
					"bulle": "Antidiarrhéiques",
					"explication": "Attention, si la diarrhée dure plus de 3 jours ou si elle est accompagnée de fièvre, de vertiges et de maux de tête, ou encore s’il a des traces de sang dans les selles, il faut consulter.<br>De plus, en cas de diarrhée, il est conseillé de boire abondamment pour prévenir la déshydratation."
				},
				{
					"groupe": "a",
					"categorie": "2",
					"nom": "pansement_gastrique",
					"bulle": "Pansement gastrique",
					"explication": "Ce médicament protège l'estomac et l'oesophage de l'acidité. Il est utilisé dans le traitement des reflux gastro oesophagien de l'adulte ou pour soulager une digestion difficile ou des ballonnements."
				},
				{
					"groupe": "a",
					"categorie": "2",
					"nom": "preservatif",
					"bulle": "Préservatif",
					"explication": "Attention, les préservatifs sont à usage unique et ont une date de péremption. Pensez à vérifier celle-ci avant l’utilisation."
				},
				{
					"groupe": "a",
					"categorie": "2",
					"nom": "carte_vitale",
					"bulle": "Carte vitale",
					"explication": "En cas de consultation ou d’achat des médicaments, elle peut vous permettre de ne pas faire l’avance de frais de la partie remboursée par l’Assurance maladie et parfois aussi de la partie prise en charge par la mutuelle."
				},
				{
					"groupe": "a",
					"categorie": "3",
					"nom": "antibiotiques",
					"bulle": "Antibiotiques",
					"explication": "Attention, vous ne devez pas utiliser des antibiotiques en dehors d’une prescription."
				},
				{
					"groupe": "b",
					"categorie": "1",
					"nom": "thermometre",
					"bulle": "Thermomètre",
					"explication": "Il existe différents types de thermomètre : auriculaire, électronique, médical et frontal. Vous pourrez le choisir en fonction de différents critères. N’hésitez pas à en discuter avec votre médecin ou votre pharmacien."
				},
				{
					"groupe": "b",
					"categorie": "1",
					"nom": "paracetamol_enfants",
					"bulle": "Paracétamol enfants",
					"explication": "Attention, il existe des médicaments spécifiques adaptés à l’âge et au poids de vos enfants. Il est conseillé de se référer à la notice pour utiliser les dosages qui conviennent. De manière générale, le recours à l’automédication doit se faire avec prudence pour les enfants. N’hésitez pas à en parler avec votre pharmacien."
				},
				{
					"groupe": "b",
					"categorie": "1",
					"nom": "solution_de_rehydratation",
					"bulle": "Solution de réhydratation",
					"explication": "Elles sont utilisées pour prévenir la déshydratation en cas de diarrhée aigues, en particulier chez les enfants de moins de 2 ans. Pour comprendre comment donner cette solution, n’hésitez pas à en parler avec votre pharmacien."
				},
				{
					"groupe": "b",
					"categorie": "1",
					"nom": "arnica",
					"bulle": "Médicament à base d’arnica",
					"explication": "L’arnica est une plante qui a des vertus anti-inflammatoires que l’on utilise en crème ou en granule homéopathique et qui est utilisée en cas de chute ou d’hématomes. Attention, les crèmes à base d’arnica ne doivent pas être utilisées sur des plaies ouvertes."
				},
				{
					"groupe": "b",
					"categorie": "1",
					"nom": "creme_solaire_enfants",
					"bulle": "Crème solaire enfant",
					"explication": "<font size=\"-1\">Attention, la peau des enfants n'est pas armée pour se défendre contre les rayons UV.<br>Il est donc très important de limiter leur exposition au soleil et de leur appliquer tout particulièrement les conseils de protection :<br>- à la plage et pour toute activité de plein air, les enfants et les adolescents doivent toujours porter au moins un tee-shirt, un chapeau et des lunettes de soleil enveloppantes norme CE 3 ;<br>il est recommandé de mettre de la crème solaire très haute protection, indice 30 et 50, sur la peau non couverte ;<br>- les bébés de moins d'un an ne doivent jamais rester au soleil, car leur peau et leurs yeux sont encore extrêmement fragiles.</font>"
				},
				{
					"groupe": "b",
					"categorie": "1",
					"nom": "carnet_de_sante",
					"bulle": "Carnet de santé",
					"explication": "C’est un document qui permet à tout professionnel de santé de connaître les antécédents médicaux de votre enfant. En cas de consultation durant les vacances, le professionnel aura ainsi tout l’historique des traitements mais aussi les allergies de votre enfant."
				},
				{
					"groupe": "b",
					"categorie": "2",
					"nom": "mal_des_transports",
					"bulle": "Médicament contre le mal des transports",
					"explication": "Le mal des transports peut en général être prévenu par des méthodes comme regarder au dehors plutôt qu’à l’intérieur du véhicule et éviter de lire en voiture. Si cela ne suffit pas, des médicaments existent en automédication. Attention, pour être efficaces, ils doivent être pris ½ heure à 1heure avant le voyage. De plus, vérifiez sur la notice ou avec votre pharmacien que le médicament que vous avez choisi est aussi adapté pour vos enfants."
				},
				{
					"groupe": "b",
					"categorie": "3",
					"nom": "medicament_dosage_adulte",
					"bulle": "Médicament dosage adulte",
					"explication": "Attention, il existe des médicaments spécifiques adaptés à l’âge et au poids de vos enfants. Les médicaments ne sont, en général, pas adaptés au moins de 6 ans. De manière générale, le recours à l’automédication doit se faire avec prudence pour les enfants. N’hésitez pas à en parler avec votre pharmacien."
				},
				{
					"groupe": "c",
					"categorie": "1",
					"nom": "paracetamol",
					"bulle": "Paracétamol",
					"explication": "Le paracétamol peut être utilisé pour lutter contre les douleurs pendant la grossesse. Cependant, l’automédication n’est pas recommandée pendant la grossesse."
				},
				{
					"groupe": "c",
					"categorie": "2",
					"nom": "spasfon",
					"bulle": "Spasfon®  (Phloroglucinol)",
					"explication": "La molécule phloroglucinol peut être utilisée contre les spasmes douloureux de l’utérus pendant la grossesse. Cependant, l’automédication n’est pas recommandée pendant la grossesse. Ainsi, n’hésitez pas à en parler à votre médecin pour confirmer que vous pouvez utiliser ce type de médicaments."
				},
				{
					"groupe": "c",
					"categorie": "3",
					"nom": "ibuprofene",
					"bulle": "Ibuprofène",
					"explication": "Attention, l’automédication peut-être dangereuse durant votre grossesse. L’ibuprofène est par exemple interdit."
				}
			]
		},
		"liens": {
			"lien_logo": "http://www.prioritesantemutualiste.fr"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/datas.json
// module id = 56
// module chunks = 1